import { Table } from "@tiptap/extension-table";

export const CustomTable = Table.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      resizable: true,
      handleWidth: 5,
      cellMinWidth: 25,
      lastColumnResizable: true,
      allowTableNodeSelection: true,
      HTMLAttributes: {
        class: "resizable-table",
      },
    };
  },

  // Note: The parent Table extension already includes columnResizing when resizable:true,
  // so we don't override addProseMirrorPlugins here to avoid duplicate plugins.

  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: "width: 100%;",
        parseHTML: (element) => element.getAttribute("style"),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return { style: attributes.style };
        },
      },
    };
  },
});
